export const METALPRESS_TECHNICIANS = '5e652af9bfcb72b8af9c4392'

export const METALPRESS_DOORS_PRODUCTION = '5f740959b6372063be2ee8fb'
export const METALPRESS_DOORS_INSTALLATION = '5f740964b6372006b02ee8fc'
export const METALPRESS_DOORS_ENGINEERING = '5f74094bb6372067392ee8fa'